var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9278 48.7167L6.2707 57.9452C5.14957 59.1403 3.21363 59.1041 2.05488 57.9452C0.896129 56.7863 0.859098 54.8511 2.05488 53.7294L11.3147 45.0431",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8213 46.822C36.9696 41.6737 36.9696 33.3267 31.8213 28.1785C26.6731 23.0302 18.3261 23.0302 13.1778 28.1785C8.02949 33.3267 8.02949 41.6737 13.1778 46.822C18.3261 51.9703 26.6731 51.9703 31.8213 46.822Z",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8126 24.5901V1.17188H48.2813L58.8281 11.7187V56.2498H17.8126V50.4105",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2421 11.7188H48.2813V1.75781",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2579 6.44531H43.0079",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2579 11.7188H33.6329",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2579 19.043H53.5548",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4141 24.3164H53.5548",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7679 34.863H53.5547",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7681 40.1365H47.1613",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1793 45.4099H53.5548",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.415 50.6833H38.9063",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4551 34.8635L21.1816 40.1371L18.5449 37.5004",
    stroke: "#A3E9E6",
    strokeWidth: 2.34375,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI4);
export default __webpack_public_path__ + "static/media/i4.d9daa44d79297aef282b4549323308db.svg";
export { ForwardRef as ReactComponent };